import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

import { DndContext, closestCenter } from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

/* =============================
   🔹 Sortable Row
============================= */
const SortableRow = ({ campaign, onDelete, onEdit, onToggleStatus }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: campaign.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style} className="hover:bg-muted/30">
      <td
        className="px-2 py-4 text-center cursor-grab"
        {...attributes}
        {...listeners}
      >
        <Icon name="GripVertical" size={16} />
      </td>

      <td className="px-4 py-4 text-center">
        <div className="w-14 h-14 mx-auto rounded-lg overflow-hidden bg-muted">
          <Image
            src={campaign.image}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </td>

      <td className="px-4 py-4 text-center break-all max-w-xs">
        {campaign.url}
      </td>

      <td className="px-4 py-4 text-center">
        <span
          className={`px-3 py-1 rounded-full text-xs font-medium ${
            campaign.is_active
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-600"
          }`}
        >
          {campaign.is_active ? "نشط" : "غير نشط"}
        </span>
      </td>

      <td className="px-4 py-4 text-center break-all max-w-xs">
        {campaign.type}
      </td>

      <td className="px-4 py-4 text-center break-all max-w-xs">
        {campaign.order}
      </td>

      {/* Actions */}
      <td className="px-4 py-4">
        <div className="flex justify-center gap-2 flex-wrap">
          {!campaign.is_active && (
            <button
              onClick={() => onToggleStatus(campaign, "active")}
              className="px-3 py-1 text-xs rounded bg-green-100 text-green-700 hover:bg-green-200"
            >
              تفعيل
            </button>
          )}

          {campaign.is_active && (
            <button
              onClick={() => onToggleStatus(campaign, "inactive")}
              className="px-3 py-1 text-xs rounded bg-red-100 text-red-600 hover:bg-red-200"
            >
              إلغاء تفعيل
            </button>
          )}

          <button className="h-8 w-8" onClick={() => onEdit(campaign)}>
            <Icon name="Edit" size={14} />
          </button>

          <button
            className="h-8 w-8 text-destructive"
            onClick={() => onDelete(campaign)}
          >
            <Icon name="Trash2" size={14} />
          </button>
        </div>
      </td>
    </tr>
  );
};

/* =============================
   🔹 Table
============================= */
const BannerTable = ({
  campaigns,
  setCampaigns,
  onReorder,
  onEdit,
  onDelete,
  onToggleStatus,
  loadingOrder,
}) => {
  const handleDragEnd = (event) => {
    if (loadingOrder) return;

    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = campaigns.findIndex((c) => c.id === active.id);
    const newIndex = campaigns.findIndex((c) => c.id === over.id);

    const newItems = arrayMove(campaigns, oldIndex, newIndex);

    setCampaigns(newItems);

    // 👇 مرر فقط العنصر المتحرك
    if (onReorder)
      onReorder({
        movedItem: newItems[newIndex],
        newOrder: newIndex + 1,
      });
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext
          items={campaigns.map((c) => c.id)}
          strategy={verticalListSortingStrategy}
        >
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-green-50">
                <tr>
                  <th></th>
                  <th className="p-3 text-center">الصورة</th>
                  <th className="p-3 text-center">الرابط</th>
                  <th className="p-3 text-center">الحالة</th>
                  <th className="p-3 text-center">النمط</th>
                  <th className="p-3 text-center">الترتيب</th>
                  <th className="p-3 text-center">الأحداث</th>
                </tr>
              </thead>

              <tbody>
                {campaigns?.map((campaign) => (
                  <SortableRow
                    key={campaign.id}
                    campaign={campaign}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onToggleStatus={onToggleStatus}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </SortableContext>
      </DndContext>

      {loadingOrder && (
        <div className="text-center py-3 text-sm">جاري حفظ الترتيب...</div>
      )}
    </div>
  );
};

export default BannerTable;
